<template>
  <Card class="rounded-2xl shadow-md">
    <CardHeader class="p-6">
      <CardTitle class="text-[18px] font-semibold">Products</CardTitle>
    </CardHeader>
    <CardContent class="p-0">
      <Table>
        <TableHeader>
          <TableRow class="bg-grey-light-50">
            <TableHead class="pl-6 max-w-[150px]">Description</TableHead>
            <TableHead>Amount</TableHead>
            <TableHead class="pr-6">State</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow v-for="item in items" :key="item.id">
            <TableCell class="pl-6 text-grey-light-900 font-medium text-[14px] truncate max-w-[150px]">{{
              item.description
            }}</TableCell>
            <TableCell class="text-grey-light-600 text-[14px]">{{ displayCurrency(item.amount) }}</TableCell>
            <TableCell class="pr-6">
              <Badge variant="outline" class="rounded-full text-[10px] text-brand-600 border-brand-200 bg-brand-50">
                {{ item.state }}
              </Badge>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { displayCurrency } from '@/utils/format.utils';

interface ProductItem {
  id: string;
  description: string;
  amount: number;
  state: string;
}

defineProps<{
  items: ProductItem[];
}>();
</script>
